import React, {useReducer, createContext, useContext, useCallback, useMemo, useEffect} from "react"
import {arrayInit1D, isAuth0Stripe} from "./common"
import {defineTerms} from "./lib/TermDefinitions.jsx"

const tab_config_file = process.env.TAB_CONFIG ?? `default-tabs.json`
const TAB_DEFINITIONS = require(`../config/${tab_config_file}`)
const tabs = Object.entries(TAB_DEFINITIONS).map(([k, _], i) => { return [k , i]}).reduce((o, [k, i]) => Object.assign(o, {[k]: i}), {})
const tabAt = (p) => Object.values(TAB_DEFINITIONS)[p]
const subTabs = (p) => tabAt(p).subTabs
const tlen = Object.values(tabs).length
console.log(`num of tabs: `, tlen)

const initByTab = (f) => Object.values(TAB_DEFINITIONS).map((t) => f(t))
const subPerspective = initByTab((tab) => {
  let t = Object.values(tab.subTabs)
  return tab.defaultSubTab ? t[t.indexOf(tab.defaultSubTab)] : t[0]
})
const mainType = initByTab((tab) => { return tab.type ?? `EQ` })
const mainGroup = initByTab((tab) => { return tab.group ?? `EQ` })
const mainLabel = initByTab((tab) => { return tab.label ?? `undefined` })
const mainCategory = initByTab((tab) => { return tab.category ?? `undefined` })
const dateIds = Object.keys(TAB_DEFINITIONS).map((k) => { return `date` + k })
const termIds = Object.keys(TAB_DEFINITIONS).map((k) => { return `term` + k })
const targetIds = Object.keys(TAB_DEFINITIONS).map((k) => { return `target` + k })
const categoryIds = Object.keys(TAB_DEFINITIONS).map((k) => { return `category` + k })
const senarioTermIds = Object.keys(TAB_DEFINITIONS).map((k) => { return `sterm` + k })
const senarioCategoryIds = Object.keys(TAB_DEFINITIONS).map((k) => { return `scategory` + k })
const senarioTrendIds = Object.keys(TAB_DEFINITIONS).map((k) => { return `strend` + k })

var activeTab = arrayInit1D(tlen, false)
activeTab[0] = true

/** 初期値 */
const initialState = {
  initialized: false,
  scrollY: 0, //ウィンドウスクロール位置
  senarioVisible: true, //シナリオランキング折り畳み状態
  getSimilar: false,
  switchPageFlag: false,
  similarExecFlag: arrayInit1D(tlen, false),
  chartUpdateFlag: false,
  inputTargetData: arrayInit1D(tlen, null),
  inputCompareList: arrayInit1D(tlen, null),
  normPriceList: arrayInit1D(tlen, null),
  rankingPage: 0,
  normChartList: initByTab((_) => { return [] }),
  normDataList: initByTab((_) => { return [] }),
  zIndex: null,
  guideInfo: {
    guideDialog: false,
    stepsEnabled: false,
    hintsEnabled: false,
    initialStep: 0,
  },
  userInfo: isAuth0Stripe() ? null : true,
  //page: `HOME`,
  page: `TREND_RANKING`,    // 初期表示画面を「トレンドランキング」画面に設定
  tabs,
  currentTab: tabAt(0),
  subTabs: subTabs(0),
  perspective: 0,
  subPerspective,
  preset: `createStandardLayout`,
  targetIds,
  termIds,
  dateIds,
  categoryIds,
  sidebarWidth: 300,
  showHeader: true,
  showFooter: true,
  showNav: true,
  accessToken: null,
  milizeToken: null,
  baseDateList: [],
  codeBaseDateList: [],
  activeTab,
  mainType,
  mainGroup,
  mainCategory,
  mainLabel,
  chartDomState: false,
  password: null,
  locale: `ja`,
  scale: `700px`,
  rankingPanel: false,
  trendPanel: false,
  mainList: initByTab((_) => { return [] }),
  categoryList: initByTab((_) => { return [] }),
  mainTarget:  initByTab((_) => { return {
    key: null,
    label: ``,
    labelEn: ``,
    labelJa: ``,
  }}),
  mainBaseDate: initByTab((_) => { return {
    key: null,
    label: ``,
  }}),
  mainTerm: initByTab((_) => { return {
    key: null,
    label: ``,
    labelEn: ``,
    labelJa: ``,
  }}),
  categoryCodeList: initByTab((_) => { return [
    {
      type: null,
      value: null,
      key: null,
      label: ``,
      labelEn: ``,
      labelJa: ``,
    },
  ]}),
  themeColor: `dark`,
  equityMarketList: [],
  trendList: [],
  fxPriceList: [],
  trendSimilarityList: initByTab((_) => { return [] }),
  searchSimilar: arrayInit1D(tlen, false),
  confirmDialog: {
    title: ``,
    message: ``,
    error: ``,
    state: false,
    content: ``,
    result: null,
  },
  loadingModal: {
    title: ``,
    message: ``,
    error: ``,
    state: false,
  },
  forwardOption: arrayInit1D(tlen, true),
  weightedAverage: arrayInit1D(tlen, 0.0),
  mainRiseFallDate: arrayInit1D(tlen, 20),
  maTerm: initByTab((_) => { return `days` }),
  maDay: initByTab((_) => { return [50, 100, 200] }),
  equityCsvState: false,
  categoryCsvState: false,
  mainListCSV: initByTab((_) => { return [] }),
  categoryListCSV: initByTab((_) => { return [] }),
  maSwitch: arrayInit1D(tlen, true),
  forecastDate: arrayInit1D(tlen, null),
  termList: defineTerms(mainType, mainGroup),
  senarioTermIds,
  senarioCategoryIds,
  senarioTrendIds,
  senarioDateList: { },
  senarioTerm: initByTab((_) => { return {
    key: null,
    label: ``,
    labelEn: ``,
    labelJa: ``,
  }}),
  senarioCategory: initByTab((_) => { return {
    type: null,
    value: null,
    labelEn: ``,
    labelJa: ``,
  }}),
  senarioTrend: initByTab((_) => { return {
    key: null,
    labelEn: ``,
    labelJa: ``,
  }}),
  senarioRank: initByTab((_) => { return {} }),
  rankingListTarget: {
    term: null,
    category: null,
    trend: null,
  },
  rankingListParam: initByTab((_) => { return {
    term: null,
    category: null,
    trend: null,
    baseDate: null,
  }}),
  loadingThreads: 10, // 一度のAPIを呼び出す最大数
  displayGraphs: 10, // 標準化グラフに一度に乗せるグラフ数
  normPage: arrayInit1D(tlen, 0), // 標準化グラフ表示ページ
}

/** メインタブ変更ログ */
const logPerspective = (store, i) => {
  const f = Object.keys(store.tabs)[store.perspective]
  const t = Object.keys(store.tabs)[i]
  console.log(`${f}=>${t}`)
}

/**
 * 変数値保存
 * @description
 * action.xxxxxは個別に項目名を付ける必要がないため、
 * 今後、action.valueに統一する予定
 */
const reducer = (store, action) => {
  switch (action.type) {
    case `INITIALIZED`:
      return {
        ...store,
        initialized: action.value
      }
    case `SCROLL_Y`:
      return {
        ...store,
        scrollY: action.value
      }
    case `SIDEBAR_WIDTH`:
      return {
        ...store,
        sidebarWidth: action.sidebarWidth,
      }
    case `SENARIO_VISIBLE`:
      return {
        ...store,
        senarioVisible: action.value,
      }
    case `GET_SIMILAR`:
      return {
        ...store,
        getSimilar: action.getSimilar,
      }
    case `SWITCH_PAGE_FLAG`:
      return {
        ...store,
        switchPageFlag: action.switchPageFlag,
      }
    case `SIMILAR_EXEC_FLAG`:
      return {
        ...store,
        simiarExecFlag: action.similarExecFlag,
      }
    case `CHART_UPDATE_FLAG`:
      return {
        ...store,
        chartUpdateFlag: action.chartUpdateFlag,
      }
    case `INPUT_TARGET_DATA`:
      return {
        ...store,
        inputTargetData: action.inputTargetData,
      }
    case `INPUT_COMPARE_LIST`:
      return {
        ...store,
        inputCompareList: action.inputCompareList,
      }
    case `NORM_PRICE_LIST`:
      return {
        ...store,
        normPriceList: action.normPriceList,
      }
    case `RANKING_PAGE`:
      return {
        ...store,
        rankingPage: action.rankingPage,
      }
    case `COLLAPSED`:
      return {
        ...store,
        collapsed: action.collapsed,
      }
    case `NORM_CHART_LIST`:
      return {
        ...store,
        normChartList: action.normChartList,
      }
    case `NORM_DATA_LIST`:
      return {
        ...store,
        normDataList: action.normDataList,
      }
    case `GUIDE_INFO`:
      return {
        ...store,
        guideInfo: action.guideInfo,
      }
    case `GUIDE_DIALOG`: {
      const guideInfo = {
        ...store.guideInfo,
        guideDialog: action.guideDialog,
      }
      return {
        ...store,
        guideInfo,
      }
    }
    case `GUIDE_INITIAL_STEP`: {
      const guideInfo = {
        ...store.guideInfo,
        initialStep: action.initialStep,
      }
      return {
        ...store,
        guideInfo,
      }
    }
    case `GUIDE_STEPS`: {
      const guideInfo = {
        ...store.guideInfo,
        stepsEnabled: action.stepsEnabled,
      }
      if (!action.stepsEnabled)
        guideInfo.initialStep = 0
      return {
        ...store,
        guideInfo,
      }
    }
    case `GUIDE_HINTS`: {
      const guideInfo = {
        ...store.guideInfo,
        hintsEnabled: action.hintsEnabled,
      }
      return {
        ...store,
        guideInfo,
      }
    }
    case `USER_INFO`:
      return {
        ...store,
        userInfo: action.userInfo,
      }
    case `PAGE`:
      return {
        ...store,
        page: action.page,
      }
    case `PERSPECTIVE`:
      logPerspective(store, action.perspective)
      return {
        ...store,
        perspective: action.perspective,
        currentTab: tabAt(action.perspective),
        subTabs: subTabs(action.perspective),
      }
    case `SUB_PERSPECTIVE`:
      return {
        ...store,
        subPerspective: action.subPerspective,
      }
    case `PRESET`:
      return {
        ...store,
        preset: action.preset,
      }
    case `SHOW_HEADER`:
      return {
        ...store,
        showHeader: action.showHeader,
      }
    case `SHOW_FOOTER`:
      return {
        ...store,
        showFooter: action.showFooter,
      }
    case `SHOW_NAV`:
      return {
        ...store,
        showNav: action.showNav,
      }
    case `ACCESS_TOKEN`:
      return {
        ...store,
        accessToken: action.accessToken,
      }
    case `MILIZE_TOKEN`:
      return {
        ...store,
        milizeToken: action.milizeToken,
      }
    case `BASE_DATE_LIST`:
      return {
        ...store,
        baseDateList: action.baseDateList,
      }
    case `CODE_BASE_DATE_LIST`:
      return {
        ...store,
        codeBaseDateList: action.codeBaseDateList,
      }
    case `ACTIVE_TAB`:
      return {
        ...store,
        activeTab: action.activeTab,
      }
    case `CHART_DOM_STATE`:
      return {
        ...store,
        chartDomState: action.chartDomState,
      }
    case `PASSWORD`:
      return {
        ...store,
        password: action.password,
      }
    case `INIT`:
      return initialState
    case `LOCALE`:
      return {
        ...store,
        locale: action.locale,
      }
    case `RANKING_PANEL`:
      return {
        ...store,
        rankingPanel: action.rankingPanel,
      }
    case `TREND_PANEL`:
      return {
        ...store,
        trendPanel: action.trendPanel,
      }
    case `SCALE`:
      return {
        ...store,
        scale: action.scale,
      }
    case `COGNITO_USER`:
      return {
        ...store,
        accessToken: action.accessToken,
      }
    case `THEME_COLOR`:
      return {
        ...store,
        themeColor: action.themeColor,
      }
    case `GET_BASE_TREND`:
      return {
        ...store,
        trendList: action.trendList,
      }
    case `MAIN_LIST`:
      return {
        ...store,
        mainList: action.mainList,
      }
    case `SET_CATEGORY_CODE`:
      return {
        ...store,
        categoryCodeList: action.categoryCodeList,
      }
    case `GET_CATEGORY_LIST`:
      return {
        ...store,
        categoryList: action.categoryList,
      }
    case `CATEGORY_LIST_CSV`:
      return {
        ...store,
        categoryListCSV: action.categoryListCSV,
      }
    case `MAIN_LIST_CSV`:
      return {
        ...store,
        mainListCSV: action.mainListCSV,
      }
    case `GET_EQ_MARKET_LIST`:
      return {
        ...store,
        equityMarketList: action.equityMarketList,
      }
    case `GET_FX_PRICE_LIST`:
      return {
        ...store,
        fxPriceList: action.fxPriceList,
      }
    case `GET_TREND_SIMILARITY_LIST`:
      return {
        ...store,
        trendSimilarityList: action.trendSimilarityList,
      }
    case `SET_FORECAST_DATE`:
      return {
        ...store,
        forecastDate: action.forecastDate,
      }
    case `SET_MAIN_BASE_DATE`:
      return {
        ...store,
        mainBaseDate: action.mainBaseDate,
      }
    case `SET_MAIN_TARGET`:
      return {
        ...store,
        mainTarget: action.mainTarget,
      }
    case `SET_MAIN_TERM`:
      return {
        ...store,
        mainTerm: action.mainTerm,
      }
    case `SEARCH_SIMILAR`:
      return {
        ...store,
        searchSimilar: action.searchSimilar,
      }
    case `CONFIRM_DIALOG`:
      return {
        ...store,
        confirmDialog: action.confirmDialog,
      }
    case `LOADING_MODAL`:
      return {
        ...store,
        loadingModal: action.loadingModal,
      }
    case `FORWARD_OPTION`:
      return {
        ...store,
        forwardOption: action.forwardOption,
      }
    case `WEIGHTED_AVERAGE`:
      return {
        ...store,
        weightedAverage: action.weightedAverage,
      }
    case `RISE_FALL_DATE`:
      return {
        ...store,
        mainRiseFallDate: action.mainRiseFallDate,
      }
    case `MOVEMENT_AVERAGE_DAY`:
      return {
        ...store,
        maDay: action.maDay,
      }
    case `MOVEMENT_AVERAGE_TERM`:
      return {
        ...store,
        maTerm: action.maTerm,
      }
    case `LOADED_EQUITY_CSV`:
      return {
        ...store,
        equityCsvState: action.equityCsvState,
      }
    case `LOADED_CATEGORY_CSV`:
      return {
        ...store,
        categoryCsvState: action.categoryCsvState,
      }
    case `MA_SWITCH`:
      return {
        ...store,
        maSwitch: action.maSwitch,
      }
    case `Z_INDEX`:
      return {
        ...store,
        zIndex: action.zIndex,
      }
    case `TERM_LIST`:
      return {
        ...store,
        termList: action.value,
      }
    case `SENARIO_DATE_LIST`:
      return {
        ...store,
        senarioDateList: action.value,
      }
    case `SENARIO_TERM`:
      return {
        ...store,
        senarioTerm: action.value,
      }
    case `SENARIO_CATEGORY`:
      return {
        ...store,
        senarioCategory: action.value,
      }
    case `SENARIO_TREND`:
      return {
        ...store,
        senarioTrend: action.value,
      }
    case `SENARIO_RANK`:
      return {
        ...store,
        senarioRank: action.value,
      }
    case `RANKING_LIST_TARGET`: {
      let wRankingListTarget = { ...store.rankingListTarget }
      if (typeof action.rankingListTarget !== 'undefined')
        wRankingListTarget = action.rankingListTarget
      if (typeof action.term !== 'undefined')
        wRankingListTarget.term = action.term
      if (typeof action.category !== 'undefined')
        wRankingListTarget.category = action.category
      if (typeof action.trend !== 'undefined')
        wRankingListTarget.trend = action.trend
      return {
        ...store,
        rankingListTarget: wRankingListTarget
      }
    }
    case `RANKING_LIST_PARAM`:
      return {
        ...store,
        rankingListParam: action.rankingListParam
      }
    case `NORM_PAGE`:
      return {
        ...store,
        normPage: action.value,
      }
    default:
      return store
  }
}

const StoreContext = createContext()
export const useStore = () => useContext(StoreContext)

const DispatchContext = createContext()
export const useDispatch = () => useContext(DispatchContext)

export const StoreProvider = ({children}) => {
  const [store, dispatch] = useReducer(reducer, initialState)

  const asyncDispatch = useCallback(async (action) => {
    switch (action.type) {
      case `UPDATE_XXXX`: {
        await new Promise((resolve) => setTimeout(resolve, 1000))
        break
      }
      default:
        dispatch(action)
    }
  }, [])

  const onReloadNeeded = useCallback(async () => {}, [])
  useEffect(() => {
    onReloadNeeded()
  }, [])

  return useMemo(() => {
    // console.log(store)
    return (
      <StoreContext.Provider
        value={{
          store,
        }}
      >
        <DispatchContext.Provider
          value={{
            dispatch,
            asyncDispatch,
            onReloadNeeded,
          }}
        >
          {children}
        </DispatchContext.Provider>
      </StoreContext.Provider>
    )
  }, [store])
}
